let sampleComponents = require('./components/sample');

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
	var FancySquares = {
		// All pages
		'common': {
	  		init: function() {
				// JavaScript to be fired on all pages

				$(document).foundation(); // Foundation JavaScript

				
				// const player = new Plyr('#player', {
				// 	/* options */
				// });

				const players = Array.from(document.querySelectorAll('.js-player')).map(p => new Plyr(p));
				// $('button.play').on('click',function(){
				// 	player.play()
				// });

				function resizeHeaderOnScroll() {
					const distanceY = window.pageYOffset || document.documentElement.scrollTop,
					shrinkOn = 100,
					headerEl = document.getElementById('js-header');
					
					if (distanceY > shrinkOn) {
					  headerEl.classList.add("header--smaller");
					} else {
					  headerEl.classList.remove("header--smaller");
					}
				  }
				  
				  window.addEventListener('scroll', resizeHeaderOnScroll);

	  		},
	  		finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
	  		}
		},
		// Home page
		'home': {
	  		init: function() {
				// JavaScript to be fired on the home page

				// fancySquareCookies.remove('modal_shown');	

				// if (fancySquareCookies.get('modal_shown') === undefined) {
    //                 fancySquareCookies.set('modal_shown', 'value', { expires: 7 });	
    //                 $('#newsletterModal').foundation('open');
    //             }

		},
	  		finalize: function() {
				// JavaScript to be fired on the home page, after the init JS
	  		}
		},
		// About us page, note the change from about-us to about_us.
		'page_template_tmpl_physicians': {
	  		init: function() {
				// JavaScript to be fired on the about us page

				$('.owl-theme--left').owlCarousel({
					loop:true,
					margin:0,
					nav:false,
					dots: true,
					dotsData: true,
					dotsContainer: '#customDots',
					items:1
				});

				$('.owl-theme--full').owlCarousel({
					loop:true,
					margin:0,
					nav:true,
					dots: true,
					items:1
				});

				$('.owl-theme--how').owlCarousel({
					loop:true,
					margin:0,
					nav:true,
					dots: true,
					items:1
				})
	  		}
		},
		// About us page, note the change from about-us to about_us.
		'page_template_tmpl_about_us': {
			init: function() {
			  // JavaScript to be fired on the about us page

				$('.owl-theme--left').owlCarousel({
					loop:true,
					margin:0,
					nav:false,
					dots: true,
					autoHeight:true,
					dotsData: true,
					dotsContainer: '#customDots',
					items:1
				});

			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = FancySquares;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
			  namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
  	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.



// WEBPACK FOOTER //
// ./assets/scripts/pages.js